require('app/www/libs/client/abDetect');
require('app/common/libs/rum/bundle');
require('app/common/libs/client/polifills/closest');
require('app/common/libs/client/polifills/smoothScroll');
require('app/www/components/blocks/YandexSansFont/YandexSansFont.scss');
require('./modernizr-bundle.js');
